export default "__VITE_ASSET__oUOxvOcE__"